import Ve, { useState as U, useRef as dr, useCallback as Ae, useEffect as Tr, forwardRef as jr } from "react";
var vr = { exports: {} }, Le = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hr;
function Ir() {
  if (hr)
    return Le;
  hr = 1;
  var n = Ve, o = Symbol.for("react.element"), c = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, u = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, h = { key: !0, ref: !0, __self: !0, __source: !0 };
  function d(m, v, E) {
    var g, b = {}, D = null, N = null;
    E !== void 0 && (D = "" + E), v.key !== void 0 && (D = "" + v.key), v.ref !== void 0 && (N = v.ref);
    for (g in v)
      i.call(v, g) && !h.hasOwnProperty(g) && (b[g] = v[g]);
    if (m && m.defaultProps)
      for (g in v = m.defaultProps, v)
        b[g] === void 0 && (b[g] = v[g]);
    return { $$typeof: o, type: m, key: D, ref: N, props: b, _owner: u.current };
  }
  return Le.Fragment = c, Le.jsx = d, Le.jsxs = d, Le;
}
var Fe = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var gr;
function Or() {
  return gr || (gr = 1, process.env.NODE_ENV !== "production" && function() {
    var n = Ve, o = Symbol.for("react.element"), c = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), u = Symbol.for("react.strict_mode"), h = Symbol.for("react.profiler"), d = Symbol.for("react.provider"), m = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), E = Symbol.for("react.suspense"), g = Symbol.for("react.suspense_list"), b = Symbol.for("react.memo"), D = Symbol.for("react.lazy"), N = Symbol.for("react.offscreen"), I = Symbol.iterator, S = "@@iterator";
    function L(e) {
      if (e === null || typeof e != "object")
        return null;
      var r = I && e[I] || e[S];
      return typeof r == "function" ? r : null;
    }
    var j = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function C(e) {
      {
        for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
          t[a - 1] = arguments[a];
        H("error", e, t);
      }
    }
    function H(e, r, t) {
      {
        var a = j.ReactDebugCurrentFrame, p = a.getStackAddendum();
        p !== "" && (r += "%s", t = t.concat([p]));
        var y = t.map(function(f) {
          return String(f);
        });
        y.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, y);
      }
    }
    var te = !1, J = !1, ne = !1, ae = !1, ie = !1, Q;
    Q = Symbol.for("react.module.reference");
    function he(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === i || e === h || ie || e === u || e === E || e === g || ae || e === N || te || J || ne || typeof e == "object" && e !== null && (e.$$typeof === D || e.$$typeof === b || e.$$typeof === d || e.$$typeof === m || e.$$typeof === v || e.$$typeof === Q || e.getModuleId !== void 0));
    }
    function oe(e, r, t) {
      var a = e.displayName;
      if (a)
        return a;
      var p = r.displayName || r.name || "";
      return p !== "" ? t + "(" + p + ")" : t;
    }
    function G(e) {
      return e.displayName || "Context";
    }
    function _(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && C("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case i:
          return "Fragment";
        case c:
          return "Portal";
        case h:
          return "Profiler";
        case u:
          return "StrictMode";
        case E:
          return "Suspense";
        case g:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case m:
            var r = e;
            return G(r) + ".Consumer";
          case d:
            var t = e;
            return G(t._context) + ".Provider";
          case v:
            return oe(e, e.render, "ForwardRef");
          case b:
            var a = e.displayName || null;
            return a !== null ? a : _(e.type) || "Memo";
          case D: {
            var p = e, y = p._payload, f = p._init;
            try {
              return _(f(y));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var F = Object.assign, z = 0, ce, R, k, P, $, V, ge;
    function be() {
    }
    be.__reactDisabledLog = !0;
    function Ue() {
      {
        if (z === 0) {
          ce = console.log, R = console.info, k = console.warn, P = console.error, $ = console.group, V = console.groupCollapsed, ge = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: be,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        z++;
      }
    }
    function ze() {
      {
        if (z--, z === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: F({}, e, {
              value: ce
            }),
            info: F({}, e, {
              value: R
            }),
            warn: F({}, e, {
              value: k
            }),
            error: F({}, e, {
              value: P
            }),
            group: F({}, e, {
              value: $
            }),
            groupCollapsed: F({}, e, {
              value: V
            }),
            groupEnd: F({}, e, {
              value: ge
            })
          });
        }
        z < 0 && C("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var se = j.ReactCurrentDispatcher, le;
    function q(e, r, t) {
      {
        if (le === void 0)
          try {
            throw Error();
          } catch (p) {
            var a = p.stack.trim().match(/\n( *(at )?)/);
            le = a && a[1] || "";
          }
        return `
` + le + e;
      }
    }
    var ue = !1, X;
    {
      var He = typeof WeakMap == "function" ? WeakMap : Map;
      X = new He();
    }
    function we(e, r) {
      if (!e || ue)
        return "";
      {
        var t = X.get(e);
        if (t !== void 0)
          return t;
      }
      var a;
      ue = !0;
      var p = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var y;
      y = se.current, se.current = null, Ue();
      try {
        if (r) {
          var f = function() {
            throw Error();
          };
          if (Object.defineProperty(f.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(f, []);
            } catch (A) {
              a = A;
            }
            Reflect.construct(e, [], f);
          } else {
            try {
              f.call();
            } catch (A) {
              a = A;
            }
            e.call(f.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (A) {
            a = A;
          }
          e();
        }
      } catch (A) {
        if (A && a && typeof A.stack == "string") {
          for (var l = A.stack.split(`
`), x = a.stack.split(`
`), w = l.length - 1, M = x.length - 1; w >= 1 && M >= 0 && l[w] !== x[M]; )
            M--;
          for (; w >= 1 && M >= 0; w--, M--)
            if (l[w] !== x[M]) {
              if (w !== 1 || M !== 1)
                do
                  if (w--, M--, M < 0 || l[w] !== x[M]) {
                    var O = `
` + l[w].replace(" at new ", " at ");
                    return e.displayName && O.includes("<anonymous>") && (O = O.replace("<anonymous>", e.displayName)), typeof e == "function" && X.set(e, O), O;
                  }
                while (w >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        ue = !1, se.current = y, ze(), Error.prepareStackTrace = p;
      }
      var Z = e ? e.displayName || e.name : "", Se = Z ? q(Z) : "";
      return typeof e == "function" && X.set(e, Se), Se;
    }
    function We(e, r, t) {
      return we(e, !1);
    }
    function Ze(e) {
      var r = e.prototype;
      return !!(r && r.isReactComponent);
    }
    function K(e, r, t) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return we(e, Ze(e));
      if (typeof e == "string")
        return q(e);
      switch (e) {
        case E:
          return q("Suspense");
        case g:
          return q("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case v:
            return We(e.render);
          case b:
            return K(e.type, r, t);
          case D: {
            var a = e, p = a._payload, y = a._init;
            try {
              return K(y(p), r, t);
            } catch {
            }
          }
        }
      return "";
    }
    var ee = Object.prototype.hasOwnProperty, Ce = {}, Me = j.ReactDebugCurrentFrame;
    function re(e) {
      if (e) {
        var r = e._owner, t = K(e.type, e._source, r ? r.type : null);
        Me.setExtraStackFrame(t);
      } else
        Me.setExtraStackFrame(null);
    }
    function Ye(e, r, t, a, p) {
      {
        var y = Function.call.bind(ee);
        for (var f in e)
          if (y(e, f)) {
            var l = void 0;
            try {
              if (typeof e[f] != "function") {
                var x = Error((a || "React class") + ": " + t + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw x.name = "Invariant Violation", x;
              }
              l = e[f](r, f, a, t, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (w) {
              l = w;
            }
            l && !(l instanceof Error) && (re(p), C("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", a || "React class", t, f, typeof l), re(null)), l instanceof Error && !(l.message in Ce) && (Ce[l.message] = !0, re(p), C("Failed %s type: %s", t, l.message), re(null));
          }
      }
    }
    var Be = Array.isArray;
    function fe(e) {
      return Be(e);
    }
    function Qe(e) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, t = r && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return t;
      }
    }
    function Ge(e) {
      try {
        return Ee(e), !1;
      } catch {
        return !0;
      }
    }
    function Ee(e) {
      return "" + e;
    }
    function De(e) {
      if (Ge(e))
        return C("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Qe(e)), Ee(e);
    }
    var Y = j.ReactCurrentOwner, Je = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ne, xe, de;
    de = {};
    function qe(e) {
      if (ee.call(e, "ref")) {
        var r = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function Xe(e) {
      if (ee.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function Ke(e, r) {
      if (typeof e.ref == "string" && Y.current && r && Y.current.stateNode !== r) {
        var t = _(Y.current.type);
        de[t] || (C('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', _(Y.current.type), e.ref), de[t] = !0);
      }
    }
    function er(e, r) {
      {
        var t = function() {
          Ne || (Ne = !0, C("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: t,
          configurable: !0
        });
      }
    }
    function rr(e, r) {
      {
        var t = function() {
          xe || (xe = !0, C("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: t,
          configurable: !0
        });
      }
    }
    var tr = function(e, r, t, a, p, y, f) {
      var l = {
        $$typeof: o,
        type: e,
        key: r,
        ref: t,
        props: f,
        _owner: y
      };
      return l._store = {}, Object.defineProperty(l._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(l, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: a
      }), Object.defineProperty(l, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: p
      }), Object.freeze && (Object.freeze(l.props), Object.freeze(l)), l;
    };
    function nr(e, r, t, a, p) {
      {
        var y, f = {}, l = null, x = null;
        t !== void 0 && (De(t), l = "" + t), Xe(r) && (De(r.key), l = "" + r.key), qe(r) && (x = r.ref, Ke(r, p));
        for (y in r)
          ee.call(r, y) && !Je.hasOwnProperty(y) && (f[y] = r[y]);
        if (e && e.defaultProps) {
          var w = e.defaultProps;
          for (y in w)
            f[y] === void 0 && (f[y] = w[y]);
        }
        if (l || x) {
          var M = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          l && er(f, M), x && rr(f, M);
        }
        return tr(e, l, x, p, a, Y.current, f);
      }
    }
    var ve = j.ReactCurrentOwner, Te = j.ReactDebugCurrentFrame;
    function W(e) {
      if (e) {
        var r = e._owner, t = K(e.type, e._source, r ? r.type : null);
        Te.setExtraStackFrame(t);
      } else
        Te.setExtraStackFrame(null);
    }
    var pe;
    pe = !1;
    function me(e) {
      return typeof e == "object" && e !== null && e.$$typeof === o;
    }
    function je() {
      {
        if (ve.current) {
          var e = _(ve.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function ar(e) {
      {
        if (e !== void 0) {
          var r = e.fileName.replace(/^.*[\\\/]/, ""), t = e.lineNumber;
          return `

Check your code at ` + r + ":" + t + ".";
        }
        return "";
      }
    }
    var Ie = {};
    function ir(e) {
      {
        var r = je();
        if (!r) {
          var t = typeof e == "string" ? e : e.displayName || e.name;
          t && (r = `

Check the top-level render call using <` + t + ">.");
        }
        return r;
      }
    }
    function Oe(e, r) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var t = ir(r);
        if (Ie[t])
          return;
        Ie[t] = !0;
        var a = "";
        e && e._owner && e._owner !== ve.current && (a = " It was passed a child from " + _(e._owner.type) + "."), W(e), C('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', t, a), W(null);
      }
    }
    function _e(e, r) {
      {
        if (typeof e != "object")
          return;
        if (fe(e))
          for (var t = 0; t < e.length; t++) {
            var a = e[t];
            me(a) && Oe(a, r);
          }
        else if (me(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var p = L(e);
          if (typeof p == "function" && p !== e.entries)
            for (var y = p.call(e), f; !(f = y.next()).done; )
              me(f.value) && Oe(f.value, r);
        }
      }
    }
    function or(e) {
      {
        var r = e.type;
        if (r == null || typeof r == "string")
          return;
        var t;
        if (typeof r == "function")
          t = r.propTypes;
        else if (typeof r == "object" && (r.$$typeof === v || r.$$typeof === b))
          t = r.propTypes;
        else
          return;
        if (t) {
          var a = _(r);
          Ye(t, e.props, "prop", a, e);
        } else if (r.PropTypes !== void 0 && !pe) {
          pe = !0;
          var p = _(r);
          C("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", p || "Unknown");
        }
        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && C("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function cr(e) {
      {
        for (var r = Object.keys(e.props), t = 0; t < r.length; t++) {
          var a = r[t];
          if (a !== "children" && a !== "key") {
            W(e), C("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", a), W(null);
            break;
          }
        }
        e.ref !== null && (W(e), C("Invalid attribute `ref` supplied to `React.Fragment`."), W(null));
      }
    }
    function Re(e, r, t, a, p, y) {
      {
        var f = he(e);
        if (!f) {
          var l = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (l += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var x = ar(p);
          x ? l += x : l += je();
          var w;
          e === null ? w = "null" : fe(e) ? w = "array" : e !== void 0 && e.$$typeof === o ? (w = "<" + (_(e.type) || "Unknown") + " />", l = " Did you accidentally export a JSX literal instead of a component?") : w = typeof e, C("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", w, l);
        }
        var M = nr(e, r, t, p, y);
        if (M == null)
          return M;
        if (f) {
          var O = r.children;
          if (O !== void 0)
            if (a)
              if (fe(O)) {
                for (var Z = 0; Z < O.length; Z++)
                  _e(O[Z], e);
                Object.freeze && Object.freeze(O);
              } else
                C("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _e(O, e);
        }
        return e === i ? cr(M) : or(M), M;
      }
    }
    function sr(e, r, t) {
      return Re(e, r, t, !0);
    }
    function lr(e, r, t) {
      return Re(e, r, t, !1);
    }
    var ur = lr, fr = sr;
    Fe.Fragment = i, Fe.jsx = ur, Fe.jsxs = fr;
  }()), Fe;
}
(function(n) {
  process.env.NODE_ENV === "production" ? n.exports = Ir() : n.exports = Or();
})(vr);
const ye = vr.exports.jsx, _r = vr.exports.jsxs, Rr = (n) => {
  const {
    children: o,
    onClick: c
  } = {
    ...n
  }, i = () => {
    c && c();
  };
  return /* @__PURE__ */ ye("button", {
    ...n,
    className: n.className ? `slr-button ${n.className}` : "slr-button",
    onClick: i,
    children: o
  });
}, B = (n) => {
  const {
    alt: o,
    onClick: c,
    src: i,
    width: u
  } = {
    ...n
  };
  return /* @__PURE__ */ ye("img", {
    ...n,
    alt: o,
    className: `slr-icon ${c ? "slr-icon-clickable" : ""} ${n.className ? n.className : ""}`,
    onClick: c,
    src: i,
    width: u || "24px"
  });
}, Sr = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTE5LDYuNDFMMTcuNTksNUwxMiwxMC41OUw2LjQxLDVMNSw2LjQxTDEwLjU5LDEyTDUsMTcuNTlMNi40MSwxOUwxMiwxMy40MUwxNy41OSwxOUwxOSwxNy41OUwxMy40MSwxMkwxOSw2LjQxWiIgLz48L3N2Zz4=", Ar = (n) => {
  const {
    onDelete: o,
    value: c,
    ...i
  } = {
    ...n
  };
  return /* @__PURE__ */ _r("span", {
    ...i,
    className: "slr-chip",
    children: [/* @__PURE__ */ ye("p", {
      children: c
    }), o ? /* @__PURE__ */ ye(B, {
      alt: "delete",
      onClick: () => {
        o && o(c);
      },
      src: Sr,
      width: "16px"
    }) : null]
  });
}, pr = (n) => {
  const {
    onDelete: o,
    values: c,
    ...i
  } = {
    ...n
  };
  return /* @__PURE__ */ ye("div", {
    ...i,
    className: "slr-chip-list",
    children: ((u) => {
      const h = [];
      return u.forEach((d) => {
        h.push(/* @__PURE__ */ ye(Ar, {
          onDelete: o,
          value: d
        }, d));
      }), h;
    })(c)
  });
}, Mr = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTEyLDRBNCw0IDAgMCwxIDE2LDhBNCw0IDAgMCwxIDEyLDEyQTQsNCAwIDAsMSA4LDhBNCw0IDAgMCwxIDEyLDRNMTIsMTRDMTYuNDIsMTQgMjAsMTUuNzkgMjAsMThWMjBINFYxOEM0LDE1Ljc5IDcuNTgsMTQgMTIsMTRaIiAvPjwvc3ZnPg==";
var mr = { exports: {} }, ke = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yr;
function Lr() {
  if (yr)
    return ke;
  yr = 1;
  var n = Ve, o = Symbol.for("react.element"), c = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, u = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, h = { key: !0, ref: !0, __self: !0, __source: !0 };
  function d(m, v, E) {
    var g, b = {}, D = null, N = null;
    E !== void 0 && (D = "" + E), v.key !== void 0 && (D = "" + v.key), v.ref !== void 0 && (N = v.ref);
    for (g in v)
      i.call(v, g) && !h.hasOwnProperty(g) && (b[g] = v[g]);
    if (m && m.defaultProps)
      for (g in v = m.defaultProps, v)
        b[g] === void 0 && (b[g] = v[g]);
    return { $$typeof: o, type: m, key: D, ref: N, props: b, _owner: u.current };
  }
  return ke.Fragment = c, ke.jsx = d, ke.jsxs = d, ke;
}
var Pe = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var br;
function kr() {
  return br || (br = 1, process.env.NODE_ENV !== "production" && function() {
    var n = Ve, o = Symbol.for("react.element"), c = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), u = Symbol.for("react.strict_mode"), h = Symbol.for("react.profiler"), d = Symbol.for("react.provider"), m = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), E = Symbol.for("react.suspense"), g = Symbol.for("react.suspense_list"), b = Symbol.for("react.memo"), D = Symbol.for("react.lazy"), N = Symbol.for("react.offscreen"), I = Symbol.iterator, S = "@@iterator";
    function L(e) {
      if (e === null || typeof e != "object")
        return null;
      var r = I && e[I] || e[S];
      return typeof r == "function" ? r : null;
    }
    var j = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function C(e) {
      {
        for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
          t[a - 1] = arguments[a];
        H("error", e, t);
      }
    }
    function H(e, r, t) {
      {
        var a = j.ReactDebugCurrentFrame, p = a.getStackAddendum();
        p !== "" && (r += "%s", t = t.concat([p]));
        var y = t.map(function(f) {
          return String(f);
        });
        y.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, y);
      }
    }
    var te = !1, J = !1, ne = !1, ae = !1, ie = !1, Q;
    Q = Symbol.for("react.module.reference");
    function he(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === i || e === h || ie || e === u || e === E || e === g || ae || e === N || te || J || ne || typeof e == "object" && e !== null && (e.$$typeof === D || e.$$typeof === b || e.$$typeof === d || e.$$typeof === m || e.$$typeof === v || e.$$typeof === Q || e.getModuleId !== void 0));
    }
    function oe(e, r, t) {
      var a = e.displayName;
      if (a)
        return a;
      var p = r.displayName || r.name || "";
      return p !== "" ? t + "(" + p + ")" : t;
    }
    function G(e) {
      return e.displayName || "Context";
    }
    function _(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && C("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case i:
          return "Fragment";
        case c:
          return "Portal";
        case h:
          return "Profiler";
        case u:
          return "StrictMode";
        case E:
          return "Suspense";
        case g:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case m:
            var r = e;
            return G(r) + ".Consumer";
          case d:
            var t = e;
            return G(t._context) + ".Provider";
          case v:
            return oe(e, e.render, "ForwardRef");
          case b:
            var a = e.displayName || null;
            return a !== null ? a : _(e.type) || "Memo";
          case D: {
            var p = e, y = p._payload, f = p._init;
            try {
              return _(f(y));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var F = Object.assign, z = 0, ce, R, k, P, $, V, ge;
    function be() {
    }
    be.__reactDisabledLog = !0;
    function Ue() {
      {
        if (z === 0) {
          ce = console.log, R = console.info, k = console.warn, P = console.error, $ = console.group, V = console.groupCollapsed, ge = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: be,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        z++;
      }
    }
    function ze() {
      {
        if (z--, z === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: F({}, e, {
              value: ce
            }),
            info: F({}, e, {
              value: R
            }),
            warn: F({}, e, {
              value: k
            }),
            error: F({}, e, {
              value: P
            }),
            group: F({}, e, {
              value: $
            }),
            groupCollapsed: F({}, e, {
              value: V
            }),
            groupEnd: F({}, e, {
              value: ge
            })
          });
        }
        z < 0 && C("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var se = j.ReactCurrentDispatcher, le;
    function q(e, r, t) {
      {
        if (le === void 0)
          try {
            throw Error();
          } catch (p) {
            var a = p.stack.trim().match(/\n( *(at )?)/);
            le = a && a[1] || "";
          }
        return `
` + le + e;
      }
    }
    var ue = !1, X;
    {
      var He = typeof WeakMap == "function" ? WeakMap : Map;
      X = new He();
    }
    function we(e, r) {
      if (!e || ue)
        return "";
      {
        var t = X.get(e);
        if (t !== void 0)
          return t;
      }
      var a;
      ue = !0;
      var p = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var y;
      y = se.current, se.current = null, Ue();
      try {
        if (r) {
          var f = function() {
            throw Error();
          };
          if (Object.defineProperty(f.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(f, []);
            } catch (A) {
              a = A;
            }
            Reflect.construct(e, [], f);
          } else {
            try {
              f.call();
            } catch (A) {
              a = A;
            }
            e.call(f.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (A) {
            a = A;
          }
          e();
        }
      } catch (A) {
        if (A && a && typeof A.stack == "string") {
          for (var l = A.stack.split(`
`), x = a.stack.split(`
`), w = l.length - 1, M = x.length - 1; w >= 1 && M >= 0 && l[w] !== x[M]; )
            M--;
          for (; w >= 1 && M >= 0; w--, M--)
            if (l[w] !== x[M]) {
              if (w !== 1 || M !== 1)
                do
                  if (w--, M--, M < 0 || l[w] !== x[M]) {
                    var O = `
` + l[w].replace(" at new ", " at ");
                    return e.displayName && O.includes("<anonymous>") && (O = O.replace("<anonymous>", e.displayName)), typeof e == "function" && X.set(e, O), O;
                  }
                while (w >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        ue = !1, se.current = y, ze(), Error.prepareStackTrace = p;
      }
      var Z = e ? e.displayName || e.name : "", Se = Z ? q(Z) : "";
      return typeof e == "function" && X.set(e, Se), Se;
    }
    function We(e, r, t) {
      return we(e, !1);
    }
    function Ze(e) {
      var r = e.prototype;
      return !!(r && r.isReactComponent);
    }
    function K(e, r, t) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return we(e, Ze(e));
      if (typeof e == "string")
        return q(e);
      switch (e) {
        case E:
          return q("Suspense");
        case g:
          return q("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case v:
            return We(e.render);
          case b:
            return K(e.type, r, t);
          case D: {
            var a = e, p = a._payload, y = a._init;
            try {
              return K(y(p), r, t);
            } catch {
            }
          }
        }
      return "";
    }
    var ee = Object.prototype.hasOwnProperty, Ce = {}, Me = j.ReactDebugCurrentFrame;
    function re(e) {
      if (e) {
        var r = e._owner, t = K(e.type, e._source, r ? r.type : null);
        Me.setExtraStackFrame(t);
      } else
        Me.setExtraStackFrame(null);
    }
    function Ye(e, r, t, a, p) {
      {
        var y = Function.call.bind(ee);
        for (var f in e)
          if (y(e, f)) {
            var l = void 0;
            try {
              if (typeof e[f] != "function") {
                var x = Error((a || "React class") + ": " + t + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw x.name = "Invariant Violation", x;
              }
              l = e[f](r, f, a, t, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (w) {
              l = w;
            }
            l && !(l instanceof Error) && (re(p), C("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", a || "React class", t, f, typeof l), re(null)), l instanceof Error && !(l.message in Ce) && (Ce[l.message] = !0, re(p), C("Failed %s type: %s", t, l.message), re(null));
          }
      }
    }
    var Be = Array.isArray;
    function fe(e) {
      return Be(e);
    }
    function Qe(e) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, t = r && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return t;
      }
    }
    function Ge(e) {
      try {
        return Ee(e), !1;
      } catch {
        return !0;
      }
    }
    function Ee(e) {
      return "" + e;
    }
    function De(e) {
      if (Ge(e))
        return C("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Qe(e)), Ee(e);
    }
    var Y = j.ReactCurrentOwner, Je = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ne, xe, de;
    de = {};
    function qe(e) {
      if (ee.call(e, "ref")) {
        var r = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function Xe(e) {
      if (ee.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function Ke(e, r) {
      if (typeof e.ref == "string" && Y.current && r && Y.current.stateNode !== r) {
        var t = _(Y.current.type);
        de[t] || (C('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', _(Y.current.type), e.ref), de[t] = !0);
      }
    }
    function er(e, r) {
      {
        var t = function() {
          Ne || (Ne = !0, C("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: t,
          configurable: !0
        });
      }
    }
    function rr(e, r) {
      {
        var t = function() {
          xe || (xe = !0, C("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: t,
          configurable: !0
        });
      }
    }
    var tr = function(e, r, t, a, p, y, f) {
      var l = {
        $$typeof: o,
        type: e,
        key: r,
        ref: t,
        props: f,
        _owner: y
      };
      return l._store = {}, Object.defineProperty(l._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(l, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: a
      }), Object.defineProperty(l, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: p
      }), Object.freeze && (Object.freeze(l.props), Object.freeze(l)), l;
    };
    function nr(e, r, t, a, p) {
      {
        var y, f = {}, l = null, x = null;
        t !== void 0 && (De(t), l = "" + t), Xe(r) && (De(r.key), l = "" + r.key), qe(r) && (x = r.ref, Ke(r, p));
        for (y in r)
          ee.call(r, y) && !Je.hasOwnProperty(y) && (f[y] = r[y]);
        if (e && e.defaultProps) {
          var w = e.defaultProps;
          for (y in w)
            f[y] === void 0 && (f[y] = w[y]);
        }
        if (l || x) {
          var M = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          l && er(f, M), x && rr(f, M);
        }
        return tr(e, l, x, p, a, Y.current, f);
      }
    }
    var ve = j.ReactCurrentOwner, Te = j.ReactDebugCurrentFrame;
    function W(e) {
      if (e) {
        var r = e._owner, t = K(e.type, e._source, r ? r.type : null);
        Te.setExtraStackFrame(t);
      } else
        Te.setExtraStackFrame(null);
    }
    var pe;
    pe = !1;
    function me(e) {
      return typeof e == "object" && e !== null && e.$$typeof === o;
    }
    function je() {
      {
        if (ve.current) {
          var e = _(ve.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function ar(e) {
      {
        if (e !== void 0) {
          var r = e.fileName.replace(/^.*[\\\/]/, ""), t = e.lineNumber;
          return `

Check your code at ` + r + ":" + t + ".";
        }
        return "";
      }
    }
    var Ie = {};
    function ir(e) {
      {
        var r = je();
        if (!r) {
          var t = typeof e == "string" ? e : e.displayName || e.name;
          t && (r = `

Check the top-level render call using <` + t + ">.");
        }
        return r;
      }
    }
    function Oe(e, r) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var t = ir(r);
        if (Ie[t])
          return;
        Ie[t] = !0;
        var a = "";
        e && e._owner && e._owner !== ve.current && (a = " It was passed a child from " + _(e._owner.type) + "."), W(e), C('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', t, a), W(null);
      }
    }
    function _e(e, r) {
      {
        if (typeof e != "object")
          return;
        if (fe(e))
          for (var t = 0; t < e.length; t++) {
            var a = e[t];
            me(a) && Oe(a, r);
          }
        else if (me(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var p = L(e);
          if (typeof p == "function" && p !== e.entries)
            for (var y = p.call(e), f; !(f = y.next()).done; )
              me(f.value) && Oe(f.value, r);
        }
      }
    }
    function or(e) {
      {
        var r = e.type;
        if (r == null || typeof r == "string")
          return;
        var t;
        if (typeof r == "function")
          t = r.propTypes;
        else if (typeof r == "object" && (r.$$typeof === v || r.$$typeof === b))
          t = r.propTypes;
        else
          return;
        if (t) {
          var a = _(r);
          Ye(t, e.props, "prop", a, e);
        } else if (r.PropTypes !== void 0 && !pe) {
          pe = !0;
          var p = _(r);
          C("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", p || "Unknown");
        }
        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && C("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function cr(e) {
      {
        for (var r = Object.keys(e.props), t = 0; t < r.length; t++) {
          var a = r[t];
          if (a !== "children" && a !== "key") {
            W(e), C("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", a), W(null);
            break;
          }
        }
        e.ref !== null && (W(e), C("Invalid attribute `ref` supplied to `React.Fragment`."), W(null));
      }
    }
    function Re(e, r, t, a, p, y) {
      {
        var f = he(e);
        if (!f) {
          var l = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (l += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var x = ar(p);
          x ? l += x : l += je();
          var w;
          e === null ? w = "null" : fe(e) ? w = "array" : e !== void 0 && e.$$typeof === o ? (w = "<" + (_(e.type) || "Unknown") + " />", l = " Did you accidentally export a JSX literal instead of a component?") : w = typeof e, C("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", w, l);
        }
        var M = nr(e, r, t, p, y);
        if (M == null)
          return M;
        if (f) {
          var O = r.children;
          if (O !== void 0)
            if (a)
              if (fe(O)) {
                for (var Z = 0; Z < O.length; Z++)
                  _e(O[Z], e);
                Object.freeze && Object.freeze(O);
              } else
                C("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _e(O, e);
        }
        return e === i ? cr(M) : or(M), M;
      }
    }
    function sr(e, r, t) {
      return Re(e, r, t, !0);
    }
    function lr(e, r, t) {
      return Re(e, r, t, !1);
    }
    var ur = lr, fr = sr;
    Pe.Fragment = i, Pe.jsx = ur, Pe.jsxs = fr;
  }()), Pe;
}
(function(n) {
  process.env.NODE_ENV === "production" ? n.exports = Lr() : n.exports = kr();
})(mr);
const s = mr.exports.jsx, T = mr.exports.jsxs, Pr = (n) => {
  const {
    contactName: o,
    hasEmail: c,
    hasPhone: i,
    ...u
  } = {
    ...n
  };
  return /* @__PURE__ */ T("div", {
    ...u,
    className: "rclib-contact-preview",
    children: [/* @__PURE__ */ s(B, {
      alt: "Contact icon",
      src: Mr
    }), /* @__PURE__ */ T("div", {
      className: "rclib-contact-preview-content",
      children: [/* @__PURE__ */ s("h3", {
        children: o
      }), /* @__PURE__ */ s("p", {
        children: ((d) => {
          const m = [];
          return d.hasEmail && m.push("Email"), d.hasPhone && m.push("Phone"), m.length === 0 ? "" : m.join(", ");
        })(n)
      })]
    })]
  });
};
const Gr = (n) => {
  const {
    contacts: o,
    ...c
  } = {
    ...n
  };
  if (o.length === 0)
    return null;
  const i = (u) => {
    const h = [];
    return u.forEach((d) => {
      h.push(/* @__PURE__ */ s(Pr, {
        contactName: d.contactName,
        hasEmail: d.hasEmail,
        hasPhone: d.hasPhone
      }));
    }), h;
  };
  return /* @__PURE__ */ s("div", {
    ...c,
    className: `rclib-contact-preview-list ${c.className ? c.className : ""}`,
    children: i(o)
  });
};
const Jr = ({
  id: n,
  initialChecked: o,
  label: c,
  onCheck: i
}) => {
  const [u, h] = U(!!o);
  return /* @__PURE__ */ T("label", {
    className: "rclib-form-checkbox-label",
    htmlFor: n,
    children: [/* @__PURE__ */ s("input", {
      checked: u,
      className: "rclib-form-checkbox",
      id: n,
      name: n,
      onChange: () => {
        i && i(!u), h(!u);
      },
      type: "checkbox"
    }), c]
  });
};
const qr = ({
  children: n,
  onSubmit: o
}) => /* @__PURE__ */ s("form", {
  className: "rclib-form-container",
  onSubmit: (i) => {
    i.preventDefault(), o();
  },
  children: n
});
const Xr = ({
  id: n,
  initialValue: o,
  label: c,
  onChange: i
}) => {
  const [u, h] = U(o || "");
  return /* @__PURE__ */ T("label", {
    className: "rclib-form-label",
    htmlFor: n,
    children: [c, /* @__PURE__ */ s("input", {
      className: "rclib-form-input rclib-form-date",
      id: n,
      name: n,
      onChange: (m) => {
        const v = m.target.value;
        i && i(new Date(v)), h(v);
      },
      type: "datetime-local",
      value: u
    })]
  });
};
function $e() {
  return $e = Object.assign || function(n) {
    for (var o = 1; o < arguments.length; o++) {
      var c = arguments[o];
      for (var i in c)
        Object.prototype.hasOwnProperty.call(c, i) && (n[i] = c[i]);
    }
    return n;
  }, $e.apply(this, arguments);
}
var wr = function(n) {
  var o = dr(n);
  return o.current = n, o;
}, Fr = function(n, o) {
  var c;
  return function() {
    for (var i = this, u = arguments.length, h = new Array(u), d = 0; d < u; d++)
      h[d] = arguments[d];
    c !== null && (clearTimeout(c), c = null), c = setTimeout(function() {
      return n.apply(i, h);
    }, o);
  };
}, $r = "\u{1F4A1} use-places-autocomplete: Google Maps Places API library must be loaded. See: https://github.com/wellyshen/use-places-autocomplete#load-the-library", Vr = function(o) {
  var c = o === void 0 ? {} : o, i = c.requestOptions, u = c.debounce, h = u === void 0 ? 200 : u, d = c.cache, m = d === void 0 ? 24 * 60 * 60 : d, v = c.cacheKey, E = v === void 0 ? "upa" : v, g = c.googleMaps, b = c.callbackName, D = c.defaultValue, N = D === void 0 ? "" : D, I = c.initOnMount, S = I === void 0 ? !0 : I, L = U(!1), j = L[0], C = L[1], H = U(N), te = H[0], J = H[1], ne = U({
    loading: !1,
    status: "",
    data: []
  }), ae = ne[0], ie = ne[1], Q = dr(), he = wr(i), oe = wr(g), G = Ae(function() {
    var R;
    if (!Q.current) {
      var k = window, P = k.google, $ = oe.current, V = ($ == null ? void 0 : $.places) || (P == null || (R = P.maps) == null ? void 0 : R.places);
      if (!V) {
        console.error($r);
        return;
      }
      Q.current = new V.AutocompleteService(), C(!0);
    }
  }, [oe]), _ = Ae(function() {
    ie({
      loading: !1,
      status: "",
      data: []
    });
  }, []), F = Ae(function(R) {
    R === void 0 && (R = E);
    try {
      sessionStorage.removeItem(R);
    } catch {
    }
  }, [E]), z = Ae(Fr(function(R) {
    var k;
    if (!R) {
      _();
      return;
    }
    ie(function($) {
      return $e({}, $, {
        loading: !0
      });
    });
    var P = {};
    try {
      P = JSON.parse(sessionStorage.getItem(E) || "{}");
    } catch {
    }
    if (m && (P = Object.keys(P).reduce(function($, V) {
      return P[V].maxAge - Date.now() >= 0 && ($[V] = P[V]), $;
    }, {}), P[R])) {
      ie({
        loading: !1,
        status: "OK",
        data: P[R].data
      });
      return;
    }
    (k = Q.current) == null || k.getPlacePredictions($e({}, he.current, {
      input: R
    }), function($, V) {
      if (ie({
        loading: !1,
        status: V,
        data: $ || []
      }), m && V === "OK") {
        P[R] = {
          data: $,
          maxAge: Date.now() + m * 1e3
        };
        try {
          sessionStorage.setItem(E, JSON.stringify(P));
        } catch {
        }
      }
    });
  }, h), [m, E, _, he]), ce = Ae(function(R, k) {
    k === void 0 && (k = !0), J(R), Q.current && k && z(R);
  }, [z]);
  return Tr(function() {
    if (!S)
      return function() {
        return null;
      };
    var R = window, k = R.google;
    return !oe.current && !(k != null && k.maps) && b ? window[b] = G : G(), function() {
      window[b] && delete window[b];
    };
  }, [b, oe, G, S]), {
    ready: j,
    value: te,
    suggestions: ae,
    setValue: ce,
    clearSuggestions: _,
    clearCache: F,
    init: G
  };
};
const Kr = ({
  labelText: n,
  onChange: o
}) => {
  const {
    value: c,
    suggestions: {
      status: i,
      data: u
    },
    setValue: h,
    clearSuggestions: d
  } = Vr(), m = (g) => {
    h(g.target.value), o(g.target.value);
  }, v = ({
    description: g
  }) => () => {
    h(g, !1), o(g), d();
  };
  return /* @__PURE__ */ T("div", {
    children: [/* @__PURE__ */ s("label", {
      children: n
    }), /* @__PURE__ */ s("input", {
      className: "location-input",
      value: c,
      onChange: m
    }), i === "OK" && /* @__PURE__ */ s("ul", {
      children: (() => u.map((g) => {
        const {
          place_id: b,
          structured_formatting: {
            main_text: D,
            secondary_text: N
          }
        } = g;
        return console.log(g), /* @__PURE__ */ s("div", {
          className: "autocomplete-suggestion",
          children: /* @__PURE__ */ T("li", {
            className: "listing-format",
            onClick: v(g),
            children: [/* @__PURE__ */ s("strong", {
              children: D
            }), " ", /* @__PURE__ */ s("small", {
              children: N
            })]
          }, b)
        });
      }))()
    })]
  });
}, et = ({
  id: n,
  initialValue: o,
  label: c,
  onChange: i,
  placeholder: u
}) => {
  const [h, d] = U(o || "");
  return /* @__PURE__ */ T("label", {
    className: "rclib-form-label",
    htmlFor: n,
    children: [c, /* @__PURE__ */ s("input", {
      className: "rclib-form-input",
      id: n,
      name: n,
      onChange: (v) => {
        const E = v.target.value;
        i && i(E), d(E);
      },
      placeholder: u,
      type: "number",
      value: h
    })]
  });
};
const rt = ({
  children: n
}) => /* @__PURE__ */ s("div", {
  className: "rclib-form-row",
  children: n
});
const Ur = ({
  id: n,
  initialValue: o,
  label: c,
  onChange: i,
  options: u,
  placeholder: h
}) => {
  const [d, m] = U(o || "");
  return /* @__PURE__ */ T("label", {
    className: "rclib-form-label",
    htmlFor: n,
    children: [c, /* @__PURE__ */ s("select", {
      className: "rclib-form-input rclib-form-select",
      id: n,
      name: n,
      onChange: (g) => {
        const b = g.target.value;
        i && b !== h && i(b), m(b);
      },
      value: d,
      children: ((g, b) => {
        const D = [];
        return g && D.push(/* @__PURE__ */ s("option", {
          value: g,
          children: g
        }, g)), b == null || b.forEach((N) => {
          D.push(/* @__PURE__ */ s("option", {
            value: N.value,
            children: N.name
          }, N.value));
        }), D.length > 0 ? D : null;
      })(h, u)
    })]
  });
};
const tt = ({
  id: n,
  initialValue: o,
  label: c,
  onChange: i,
  options: u,
  placeholder: h
}) => {
  const [d, m] = U([]), v = (N) => {
    const I = [...N];
    return I.sort((S, L) => S.name.localeCompare(L.name)), I;
  }, E = (N) => {
    const I = [...N];
    return I.sort((S, L) => S.localeCompare(L)), I;
  }, g = (N, I) => {
    if (!N)
      return [];
    const S = N.filter((L) => !I.includes(L.name));
    return v(S);
  }, b = (N) => {
    const I = u == null ? void 0 : u.find((L) => L.value === N);
    if (!I)
      return;
    const S = E([...d, I.name]);
    m(S), i && i(S);
  }, D = (N) => {
    const I = u == null ? void 0 : u.find((j) => j.name === N), S = d.find((j) => j === N);
    if (!I || !S)
      return;
    const L = d.filter((j) => j !== N);
    m(L), i && i(L);
  };
  return /* @__PURE__ */ T("div", {
    className: "rclib-form-select-chips",
    children: [/* @__PURE__ */ s(Ur, {
      id: n,
      initialValue: o,
      label: c,
      onChange: b,
      options: g(u, d),
      placeholder: h
    }), d.length > 0 ? /* @__PURE__ */ s(pr, {
      onDelete: D,
      values: d
    }) : null]
  });
};
const nt = ({
  disabled: n,
  value: o
}) => /* @__PURE__ */ s("input", {
  className: `slr-button rclib-form-input rclib-form-submit ${n ? "rclib-form-submit-disabled" : ""}`,
  type: "submit",
  value: o
});
const at = ({
  id: n,
  initialValue: o,
  label: c,
  onChange: i,
  placeholder: u
}) => {
  const [h, d] = U(o || "");
  return /* @__PURE__ */ T("label", {
    className: "rclib-form-label",
    htmlFor: n,
    children: [c, /* @__PURE__ */ s("textarea", {
      className: "rclib-form-input rclib-form-text-area",
      id: n,
      name: n,
      onChange: (v) => {
        const E = v.target.value;
        i && i(E), d(E);
      },
      placeholder: u,
      value: h
    })]
  });
}, it = jr((n, o) => {
  const [c, i] = U(n.initialValue || ""), u = (h) => {
    const d = h.target.value;
    n.onChange && n.onChange(d), i(d);
  };
  return n.required ? /* @__PURE__ */ T("label", {
    className: "rclib-form-label",
    htmlFor: n.id,
    children: [n.label, /* @__PURE__ */ s("input", {
      className: "rclib-form-input",
      id: n.id,
      name: n.id,
      onChange: u,
      placeholder: n.placeholder,
      type: "text",
      value: c,
      pattern: n.pattern,
      required: n.required
    })]
  }) : /* @__PURE__ */ T("label", {
    className: "rclib-form-label",
    htmlFor: n.id,
    children: [n.label, /* @__PURE__ */ s("input", {
      ref: o,
      className: "rclib-form-input",
      id: n.id,
      name: n.id,
      onChange: u,
      placeholder: n.placeholder,
      type: "text",
      value: c,
      pattern: n.pattern
    })]
  });
}), Er = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTIwLDJINEEyLDIgMCAwLDAgMiw0VjIyTDYsMThIMjBBMiwyIDAgMCwwIDIyLDE2VjRDMjIsMi44OSAyMS4xLDIgMjAsMloiIC8+PC9zdmc+";
const Cr = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExIDAuMjAwMDEyTDE0LjYgNy40MDAwMUwyMS44IDguMzAwMDFMMTYuODU2IDEzLjg0NEwxOC4yIDIxLjhMMTEgMTguMkwzLjc5OTk1IDIxLjhMNS4xNTU5NSAxMy44NDRMMC4xOTk5NTEgOC4zMDAwMUw3LjM5OTk1IDcuNDAwMDFMMTEgMC4yMDAwMTJaIiBmaWxsPSIjOUNBRjg4Ii8+Cjwvc3ZnPgo=", zr = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExIDAuMjAwMDEyTDcuMzk5OTUgNy40MDAwMUwwLjE5OTk1MSA4LjMwMDAxTDUuMTU1OTUgMTMuODQ0TDMuNzk5OTUgMjEuOEwxMSAxOC4yTDE4LjIgMjEuOEwxNi44NTYgMTMuODQ0TDIxLjggOC4zMDAwMUwxNC42IDcuNDAwMDFMMTEgMC4yMDAwMTJaTTExIDIuODg4MDFMMTMuODA4IDguNTE2MDFMMTkuMzg4IDkuMjEyMDFMMTUuNTcyIDEzLjQ4NEwxNi42MTYgMTkuNjY0TDExIDE2Ljg1Nkw1LjM4Mzk1IDE5LjY2NEw2LjQyNzk1IDEzLjQ4NEwyLjYxMTk1IDkuMjEyMDFMOC4xOTE5NSA4LjUxNjAxTDExIDIuODg4MDFaIiBmaWxsPSIjOUNBRjg4Ii8+Cjwvc3ZnPgo=", Dr = ({
  onClick: n,
  display: o,
  rating: c,
  numStars: i,
  precision: u
}) => {
  const [h, d] = U(c), [m, v] = U(-1), [E, g] = U(!1), b = dr(document.createElement("div")), D = (j) => {
    var ae;
    const {
      width: C,
      left: H
    } = b.current.getBoundingClientRect(), J = (j.clientX - H) / C * i, ne = Math.round((J + u / 2) / u) * u;
    return Number(ne.toFixed(((ae = u.toString().split(".")[1]) == null ? void 0 : ae.length) || 0));
  };
  return /* @__PURE__ */ s("div", {
    ...{
      className: "stars",
      ref: b,
      onClick: o ? void 0 : (j) => {
        g(!1);
        let C = D(j);
        d(C), n && n(C);
      },
      onMouseMove: o ? void 0 : (j) => {
        g(!0), v(D(j));
      },
      onMouseLeave: o ? void 0 : () => {
        v(-1), g(!1);
      }
    },
    children: [...new Array(i)].map((j, C) => {
      const H = E ? m : h, te = H === -1 || H < C + 1, J = Math.ceil(H) === C + 1;
      return /* @__PURE__ */ T("div", {
        className: "star",
        children: [/* @__PURE__ */ s("div", {
          style: {
            width: J ? `${H % 1 * 100}%` : "0%",
            overflow: "hidden",
            position: "absolute"
          },
          children: /* @__PURE__ */ s("img", {
            src: Cr
          })
        }), /* @__PURE__ */ s("div", {
          children: te ? /* @__PURE__ */ s("img", {
            src: zr
          }) : /* @__PURE__ */ s("img", {
            src: Cr
          })
        })]
      }, C);
    })
  });
};
const Hr = ({
  onVote: n,
  reviewVote: o
}) => {
  let [c, i] = U(o);
  const u = (h) => {
    n(c, h), c == h ? i(0) : i(h);
  };
  return /* @__PURE__ */ T("div", {
    className: "voting",
    children: [/* @__PURE__ */ s("div", {
      className: "upvote",
      onClick: () => u(1),
      children: c == 1 ? /* @__PURE__ */ s("svg", {
        width: "18",
        height: "20",
        viewBox: "0 0 18 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ s("path", {
          d: "M0.999298 11.9812H4.9993V18.9813C4.9993 19.2465 5.10466 19.5008 5.29219 19.6884C5.47973 19.8759 5.73408 19.9813 5.9993 19.9813H11.9993C12.2645 19.9813 12.5189 19.8759 12.7064 19.6884C12.8939 19.5008 12.9993 19.2465 12.9993 18.9813V11.9812H16.9993C17.1876 11.9809 17.3719 11.9275 17.5312 11.8272C17.6905 11.7268 17.8182 11.5836 17.8998 11.4139C17.9814 11.2442 18.0134 11.0549 17.9923 10.8679C17.9711 10.6808 17.8977 10.5035 17.7803 10.3562L9.7803 0.35625C9.3993 -0.11875 8.5993 -0.11875 8.2183 0.35625L0.218298 10.3562C0.100937 10.5035 0.027469 10.6808 0.00633031 10.8679C-0.0148084 11.0549 0.0172391 11.2442 0.0987929 11.4139C0.180347 11.5836 0.3081 11.7268 0.467386 11.8272C0.626672 11.9275 0.811032 11.9809 0.999298 11.9812V11.9812Z",
          fill: "#9CAF88"
        })
      }) : /* @__PURE__ */ s("svg", {
        width: "18",
        height: "20",
        viewBox: "0 0 18 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ s("path", {
          d: "M5.4993 11.9812V11.4812H4.9993L1.00015 11.4813C1 11.4813 0.999852 11.4812 0.999704 11.4812C0.905632 11.481 0.813524 11.4543 0.733927 11.4041C0.654204 11.3539 0.590264 11.2822 0.549446 11.1973C0.508628 11.1123 0.492589 11.0176 0.503169 10.924C0.51374 10.8304 0.550462 10.7418 0.609121 10.6681C0.609167 10.6681 0.609213 10.668 0.609259 10.6679L8.60833 0.669098C8.60835 0.669071 8.60838 0.669043 8.6084 0.669016C8.78926 0.443661 9.20934 0.443661 9.3902 0.669016C9.39022 0.669043 9.39024 0.669071 9.39026 0.669098L17.3893 10.6679C17.4481 10.7416 17.4848 10.8304 17.4954 10.924C17.506 11.0176 17.49 11.1123 17.4492 11.1973C17.4083 11.2822 17.3444 11.3539 17.2647 11.4041C17.1851 11.4543 17.093 11.481 16.9989 11.4812C16.9987 11.4812 16.9986 11.4813 16.9984 11.4813L12.9993 11.4812H12.4993V11.9812V18.9813C12.4993 19.1139 12.4466 19.241 12.3529 19.3348C12.2591 19.4286 12.1319 19.4813 11.9993 19.4813H5.9993C5.86669 19.4813 5.73951 19.4286 5.64574 19.3348C5.55198 19.241 5.4993 19.1139 5.4993 18.9813V11.9812Z",
          stroke: "#9A937D"
        })
      })
    }), /* @__PURE__ */ s("div", {
      className: "downvote",
      onClick: () => u(-1),
      children: c == -1 ? /* @__PURE__ */ s("svg", {
        width: "18",
        height: "20",
        viewBox: "0 0 18 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ s("path", {
          d: "M17.9003 8.566C17.8185 8.3965 17.6906 8.25348 17.5312 8.15337C17.3719 8.05326 17.1875 8.0001 16.9993 8H12.9993V1C12.9993 0.734784 12.8939 0.48043 12.7064 0.292893C12.5189 0.105357 12.2645 0 11.9993 0H5.9993C5.73408 0 5.47973 0.105357 5.29219 0.292893C5.10466 0.48043 4.9993 0.734784 4.9993 1V8H0.999298C0.811032 8.00032 0.626672 8.05373 0.467386 8.15409C0.3081 8.25445 0.180347 8.3977 0.0987929 8.56738C0.0172391 8.73707 -0.0148084 8.92631 0.00633031 9.11339C0.027469 9.30047 0.100937 9.47779 0.218298 9.625L8.2183 19.625C8.31198 19.7422 8.43082 19.8367 8.56601 19.9017C8.70121 19.9667 8.84929 20.0005 8.9993 20.0005C9.1493 20.0005 9.29739 19.9667 9.43258 19.9017C9.56778 19.8367 9.68662 19.7422 9.7803 19.625L17.7803 9.625C18.0203 9.324 18.0663 8.913 17.9003 8.566Z",
          fill: "#9CAF88"
        })
      }) : /* @__PURE__ */ s("svg", {
        width: "18",
        height: "20",
        viewBox: "0 0 18 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ s("path", {
          d: "M12.4993 8V8.5H12.9993H16.999C17.0932 8.50005 17.1855 8.52666 17.2653 8.57676C17.3447 8.62668 17.4086 8.6979 17.4495 8.78231C17.5329 8.95709 17.5093 9.16285 17.3894 9.31329L9.38986 19.3127L9.3898 19.3127C9.34296 19.3713 9.28354 19.4186 9.21594 19.4511C9.14834 19.4836 9.0743 19.5005 8.9993 19.5005C8.9243 19.5005 8.85026 19.4836 8.78266 19.4511C8.71506 19.4186 8.65564 19.3713 8.6088 19.3127L8.60873 19.3127L0.609259 9.31331C0.609213 9.31325 0.609167 9.3132 0.609121 9.31314C0.550462 9.23949 0.51374 9.15081 0.503169 9.05725C0.492589 8.96362 0.508628 8.8689 0.549446 8.78397C0.590264 8.69905 0.654204 8.62735 0.733927 8.57712C0.813524 8.52697 0.905632 8.50024 0.999704 8.5C0.999852 8.5 1 8.5 1.00015 8.5L4.9993 8.5H5.4993V8V1C5.4993 0.867392 5.55198 0.740215 5.64574 0.646447C5.73951 0.552678 5.86669 0.5 5.9993 0.5H11.9993C12.1319 0.5 12.2591 0.552678 12.3529 0.646447C12.4466 0.740215 12.4993 0.867392 12.4993 1V8Z",
          stroke: "#9A937D"
        })
      })
    })]
  });
};
const Wr = (n) => {
  const {
    date: o,
    title: c,
    location: i,
    time: u,
    rating: h,
    body: d,
    upvotes: m,
    profileId: v,
    reviewId: E,
    reviewVote: g,
    onUserVote: b
  } = {
    ...n
  };
  let [D, N] = U(m);
  return /* @__PURE__ */ T("div", {
    className: "rclib-review-preview",
    children: [/* @__PURE__ */ s(B, {
      alt: "Review icon",
      className: "rclib-review-preview-icon",
      src: Er,
      width: "32px"
    }), /* @__PURE__ */ T("div", {
      className: "rclib-review-preview-content",
      children: [/* @__PURE__ */ T("div", {
        className: "rclib-review-preview-header",
        children: [/* @__PURE__ */ s("h2", {
          children: c
        }), /* @__PURE__ */ s(Dr, {
          display: !0,
          rating: h,
          numStars: 5,
          precision: -1
        })]
      }), /* @__PURE__ */ T("p", {
        children: [i, " on ", o, " at ", u]
      }), /* @__PURE__ */ s("div", {
        className: "rclib-review-preview-body",
        children: /* @__PURE__ */ s("p", {
          children: d
        })
      }), b != null ? /* @__PURE__ */ T("div", {
        className: "rclib-review-voting",
        children: [/* @__PURE__ */ T("p", {
          children: [D, " people found this helpful"]
        }), /* @__PURE__ */ s(Hr, {
          onVote: (I, S) => {
            I == S ? b(E, v, 0) : b(E, v, S), S == 1 && I != 1 ? N(D + 1) : I == 1 && N(D - 1);
          },
          reviewVote: g
        })]
      }) : null]
    })]
  });
};
const ot = (n) => {
  const {
    reviews: o,
    onUserVote: c,
    ...i
  } = {
    ...n
  };
  if (o.length === 0)
    return null;
  const u = (h) => {
    const d = [];
    return h.forEach((m) => {
      d.push(/* @__PURE__ */ s(Wr, {
        date: m.date,
        title: m.title,
        location: m.location,
        time: m.time,
        rating: m.rating,
        body: m.body,
        upvotes: m.upvotes,
        downvotes: m.downvotes,
        profileId: m.profileId,
        reviewId: m.reviewId,
        reviewVote: m.reviewVote,
        onUserVote: c
      }, m.reviewId));
    }), d;
  };
  return /* @__PURE__ */ s("div", {
    ...i,
    className: `rclib-review-preview-list ${i.className ? i.className : ""}`,
    children: u(o)
  });
}, Nr = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTE5LDYuNDFMMTcuNTksNUwxMiwxMC41OUw2LjQxLDVMNSw2LjQxTDEwLjU5LDEyTDUsMTcuNTlMNi40MSwxOUwxMiwxMy40MUwxNy41OSwxOUwxOSwxNy41OUwxMy40MSwxMkwxOSw2LjQxWiIgLz48L3N2Zz4=", xr = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTEyLDExLjVBMi41LDIuNSAwIDAsMSA5LjUsOUEyLjUsMi41IDAgMCwxIDEyLDYuNUEyLjUsMi41IDAgMCwxIDE0LjUsOUEyLjUsMi41IDAgMCwxIDEyLDExLjVNMTIsMkE3LDcgMCAwLDAgNSw5QzUsMTQuMjUgMTIsMjIgMTIsMjJDMTIsMjIgMTksMTQuMjUgMTksOUE3LDcgMCAwLDAgMTIsMloiIC8+PC9zdmc+";
const Zr = (n) => {
  const {
    contacts: o,
    location: c,
    onClick: i,
    onDelete: u,
    time: h,
    title: d,
    tripID: m
  } = {
    ...n
  };
  return /* @__PURE__ */ T("div", {
    className: "rclib-trip-preview",
    children: [/* @__PURE__ */ s(B, {
      alt: "Location icon",
      className: "rclib-trip-preview-icon",
      src: xr,
      width: "32px"
    }), /* @__PURE__ */ T("div", {
      className: "rclib-trip-preview-content",
      children: [/* @__PURE__ */ s("h2", {
        className: i ? "rclib-trip-title-clickable" : void 0,
        onClick: i ? () => {
          i && i(m);
        } : void 0,
        children: d
      }), /* @__PURE__ */ s("p", {
        children: c
      }), /* @__PURE__ */ s("p", {
        children: h
      }), /* @__PURE__ */ s(pr, {
        values: o
      })]
    }), u ? /* @__PURE__ */ s(B, {
      alt: "Delete",
      className: "rclib-trip-preview-delete",
      onClick: () => {
        u && u(m);
      },
      src: Nr
    }) : null]
  });
};
const ct = (n) => {
  const {
    onDelete: o,
    trips: c,
    ...i
  } = {
    ...n
  };
  if (c.length === 0)
    return null;
  const u = (d) => {
    o && o(d);
  }, h = (d) => {
    const m = [];
    return d.forEach((v) => {
      m.push(/* @__PURE__ */ s(Zr, {
        contacts: v.contacts,
        location: v.location,
        onClick: v.onClick,
        onDelete: o ? u : void 0,
        time: v.time,
        title: v.title,
        tripID: v.tripID
      }, v.tripID));
    }), m;
  };
  return /* @__PURE__ */ s("div", {
    ...i,
    className: `rclib-trip-preview-list ${i.className ? i.className : ""}`,
    children: h(c)
  });
}, Yr = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTE5LDE5SDVWOEgxOU0xNiwxVjNIOFYxSDZWM0g1QzMuODksMyAzLDMuODkgMyw1VjE5QTIsMiAwIDAsMCA1LDIxSDE5QTIsMiAwIDAsMCAyMSwxOVY1QzIxLDMuODkgMjAuMSwzIDE5LDNIMThWMU0xNywxMkgxMlYxN0gxN1YxMloiIC8+PC9zdmc+", Br = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTIwLjcxLDcuMDRDMjEuMSw2LjY1IDIxLjEsNiAyMC43MSw1LjYzTDE4LjM3LDMuMjlDMTgsMi45IDE3LjM1LDIuOSAxNi45NiwzLjI5TDE1LjEyLDUuMTJMMTguODcsOC44N00zLDE3LjI1VjIxSDYuNzVMMTcuODEsOS45M0wxNC4wNiw2LjE4TDMsMTcuMjVaIiAvPjwvc3ZnPg==";
const st = (n) => {
  const {
    contacts: o,
    dateTime: c,
    locationName: i,
    onEdit: u,
    tripID: h,
    tripName: d,
    ...m
  } = {
    ...n
  };
  return /* @__PURE__ */ T("div", {
    ...m,
    className: "rclib-trip-view",
    children: [/* @__PURE__ */ T("div", {
      className: "rclib-trip-view-content",
      children: [/* @__PURE__ */ s("h3", {
        children: d
      }), /* @__PURE__ */ T("div", {
        className: "rclib-trip-view-row",
        children: [/* @__PURE__ */ s(B, {
          alt: "Edit",
          src: xr
        }), /* @__PURE__ */ s("p", {
          children: i
        })]
      }), /* @__PURE__ */ T("div", {
        className: "rclib-trip-view-row",
        children: [/* @__PURE__ */ s(B, {
          alt: "Edit",
          src: Yr
        }), /* @__PURE__ */ s("p", {
          children: c
        })]
      }), /* @__PURE__ */ T("div", {
        className: "rclib-trip-view-row",
        children: [/* @__PURE__ */ s(B, {
          alt: "Edit",
          src: Mr
        }), /* @__PURE__ */ s(pr, {
          values: o
        })]
      })]
    }), /* @__PURE__ */ s(Rr, {
      className: "rclib-trip-view-edit",
      onClick: () => {
        u && u(h);
      },
      children: /* @__PURE__ */ s(B, {
        alt: "Edit",
        src: Br,
        width: "24px"
      })
    })]
  });
};
const lt = (n) => {
  const {
    date: o,
    title: c,
    location: i,
    time: u,
    rating: h,
    body: d,
    profileId: m,
    reviewId: v,
    onDelete: E,
    onModify: g
  } = {
    ...n
  };
  return /* @__PURE__ */ T("div", {
    className: "rclib-review-preview",
    children: [/* @__PURE__ */ s(B, {
      alt: "Review icon",
      className: "rclib-review-preview-icon",
      src: Er,
      width: "32px"
    }), /* @__PURE__ */ T("div", {
      className: "rclib-review-preview-content",
      children: [/* @__PURE__ */ T("div", {
        className: "rclib-review-preview-header",
        children: [/* @__PURE__ */ s("h2", {
          onClick: g,
          children: c
        }), /* @__PURE__ */ s(Dr, {
          display: !0,
          rating: h,
          numStars: 5,
          precision: -1
        })]
      }), /* @__PURE__ */ s("div", {
        className: "rclib-review-preview-header",
        children: /* @__PURE__ */ T("p", {
          children: [i, " on ", o, " at ", u]
        })
      }), /* @__PURE__ */ s("div", {
        className: "rclib-review-preview-body",
        children: /* @__PURE__ */ s("p", {
          children: d
        })
      }), /* @__PURE__ */ s("div", {
        className: "rclib-review-preview-delete",
        children: E ? /* @__PURE__ */ s(B, {
          alt: "Delete",
          className: "rclib-review-preview-delete-icon",
          onClick: E,
          src: Nr
        }) : null
      })]
    })]
  });
};
export {
  Pr as ContactPreview,
  Gr as ContactPreviewList,
  Jr as FormCheckbox,
  qr as FormContainer,
  Xr as FormDate,
  Kr as FormLocation,
  et as FormNumber,
  rt as FormRow,
  Ur as FormSelect,
  tt as FormSelectChips,
  nt as FormSubmit,
  it as FormText,
  at as FormTextArea,
  Wr as ReviewPreview,
  lt as ReviewPreviewDelete,
  ot as ReviewPreviewList,
  Dr as StarRating,
  Zr as TripPreview,
  ct as TripPreviewList,
  st as TripView,
  Hr as Vote
};
